/*

TemplateLoader
==============

A service to register templates and load them at a later time. Primary use-case
is loading modals with ng-include only when needed.


Usage
-----

```javascript
$scope.templates = TemplateLoader.register('key', 'url');
// or register multiple templates at once
$scope.templates = TemplateLoader.register({
    key1: 'url1',
    key2: 'url2'
});


// later after some user interaction
TemplateLoader.load('key').then(function(){
    // template loaded
});
```

```html
<div ng-include src="templates.key"></div>
<div ng-include src="templates.key2"></div>
```


Methods
-------

-	`register(key, url)`
    Register a template to load. Accepts a key and a url where the template is located. Returns an object to use in ng-include.

-	`register(map)`
    Register multiple templates using an object with key url values.

-	`load(key)`
    Load a template. Returns a promise that's resolved when the template loads. Promise is resolved immediately if the template has already been loaded.

 */

angular.module('jv.Common.TemplateLoader', [])

.factory('TemplateLoader', ['$injector', function($injector) {

    var $get = $injector.get,
        $http = $get('$http'),
        $templateCache = $get('$templateCache'),
        $q = $get('$q'),
        $timeout = $get('$timeout');

    var templates = {},
        scope = {};

    function register (key, value) {
        var map = key;

        if (!angular.isObject(key)) {
            map = {};
            map[key] = value;
        }

        angular.forEach(map, function(url, tpl) {
            if (templates[tpl]) {
                return;
            }
            templates[tpl] = url;
            scope[tpl] = false;
        });

        return scope;
    }

    function load (key, controller) {
        var url = templates[key],
            deferred = $q.defer();

        if (!url) {
            return;
        }

        if (scope[key]) {
            deferred.resolve();
        }
        else {
            $http.get(url).then(function(res) {
                if(angular.isDefined(controller) && angular.isDefined(res.data)){
                    res.data = '<div ng-controller="{0}" class="appear-in">{1}</div>'.format(controller, res.data);
                }
                $templateCache.put(url, res.data);
                scope[key] = url;
                $timeout(function() {
                    // timeout avoids issues when include is repeated
                    // and uses a common directive like jv.Modal
                    deferred.resolve();
                });
            });
        }

        return deferred.promise;
    }

    //@TODO: remove when backend return views as JSON object
    function cleanKey(item){
        return item.replace(/"/g,'');
    }

    function buildObject(objectString){
        var keyValues = objectString.split(',');
        var obj = {};
        angular.forEach(keyValues, function(keyValue){
            var item = keyValue.split(':');
            obj[cleanKey(item[0])] = typeof(item[1]) === 'boolean' ? item[1] : item[1] === 'true';
        });
        return obj;
    }

    function fetchJSVariableValue(data, identifier){
        var identifierExpression = identifier + '=';
        if(data.indexOf(identifierExpression)>=0){
            var jsVariableValue = data.substr(data.indexOf(identifierExpression)+identifierExpression.length);
            jsVariableValue = jsVariableValue.substr(1, jsVariableValue.length-2);
            return buildObject(jsVariableValue);
        }
        return {};
    }

    function inject(url, key){
        var deferred = $q.defer();
        $http.get(url).then(function(res) {
            deferred.resolve(
                angular.extend(res.data, {
                    views: fetchJSVariableValue(res.data[key] || res.data.views, 'views')
                })
            );
        }).catch(function(err){
            //handle error page redirection
            if(err){
                if(err.status && err.status === 403) {
                    location.href = '/admin/info/accessDenied.html';
                } else {
                    location.href = '/admin/info/error.html';
                }
            }
            deferred.reject(err);
        });
        return deferred.promise;
    }
    return {
        register: register,
        load: load,
        scope: scope,
        inject: inject
    };
}]);


